import { availableLanguages, chosenLanguage, setLanguage } from '@/lib/i18n.mjs';

import { deselect, loadTemplate, select } from '@/utils/dom.ts';
import { NodesProxy } from '@/utils/elementProxies.mjs';
import showSettingSaved from '@/utils/settingSaved.ts';

loadTemplate('c-language-switcher').then(({ content }) => {
  window.customElements.define(
    'c-language-switcher',
    class extends HTMLElement {
      constructor() {
        super();
        this.nodes = new NodesProxy(this);
      }

      async handleEvent({ target: { value } }) {
        if (value !== chosenLanguage) {
          await setLanguage(value);
          showSettingSaved(this.nodes.languageSaved);
        }
      }

      update() {
        for (const option of this.nodes.languageSelect.querySelectorAll('option')) {
          if (option.value === chosenLanguage) {
            select(option);
          } else {
            deselect(option);
          }
        }
      }

      connectedCallback() {
        this.appendChild(content.cloneNode(true));

        availableLanguages.forEach(async (l) => {
          const option = document.createElement('option');
          option.dataset.translationKey = l;
          option.value = l;
          option.textContent = l;

          if (l === chosenLanguage) {
            select(option);
          }

          this.nodes.languageSelect.appendChild(option);
        });

        this.nodes.languageSelect.addEventListener('change', this);
      }

      disconnectedCallback() {
        this.nodes.languageSelect.removeEventListener('change', this);
      }
    },
  );
});
